import { DateTime } from 'luxon';
export var Weekday;
(function (Weekday) {
    Weekday[Weekday["MONDAY"] = 1] = "MONDAY";
    Weekday[Weekday["TUESDAY"] = 2] = "TUESDAY";
    Weekday[Weekday["WEDNESDAY"] = 3] = "WEDNESDAY";
    Weekday[Weekday["THURSDAY"] = 4] = "THURSDAY";
    Weekday[Weekday["FRIDAY"] = 5] = "FRIDAY";
    Weekday[Weekday["SATURDAY"] = 6] = "SATURDAY";
    Weekday[Weekday["SUNDAY"] = 7] = "SUNDAY";
})(Weekday || (Weekday = {}));
export default class DateTimeUtils {
    static getUtcToday(hour = 0, minute = 0, second = 0, millisecond = 0) {
        return DateTime.utc().set({
            hour,
            minute,
            second,
            millisecond,
        }).toJSDate();
    }
    static getUtcNow() {
        return DateTime.utc().toJSDate();
    }
    static getUtcYesterday() {
        return DateTimeUtils.getUtcPreviousDay(1);
    }
    static getUtcPreviousDay(daysNumber, date) {
        let dateTimeToUse;
        if (!date) {
            dateTimeToUse = DateTime.utc();
        }
        else {
            dateTimeToUse = DateTime.fromJSDate(date, { zone: 'UTC' });
        }
        return DateTimeUtils.clearTime(dateTimeToUse)
            .minus({ days: daysNumber })
            .toJSDate();
    }
    static getUtcFutureDay(daysNumber, date) {
        let dateTimeToUse;
        if (!date) {
            dateTimeToUse = DateTime.utc();
        }
        else {
            dateTimeToUse = DateTime.fromJSDate(date, { zone: 'UTC' });
        }
        return DateTimeUtils.clearTime(dateTimeToUse)
            .plus({ days: daysNumber })
            .toJSDate();
    }
    static getUtcMonthEnd(date) {
        let dateTimeToUse;
        if (!date) {
            dateTimeToUse = DateTime.utc();
        }
        else {
            dateTimeToUse = DateTime.fromJSDate(date, { zone: 'UTC' });
        }
        return DateTimeUtils.clearTime(dateTimeToUse)
            .plus({ months: 1 })
            .set({ day: 1 })
            .minus({ days: 1 })
            .toJSDate();
    }
    static getUtcYearStart() {
        return DateTimeUtils.clearTime(DateTime.utc())
            .set({
            day: 1,
            month: 1
        })
            .toJSDate();
    }
    static getUtcMonthStart() {
        return DateTimeUtils.clearTime(DateTime.utc())
            .set({
            day: 1,
        })
            .toJSDate();
    }
    static getUtcLastMonthStart() {
        return DateTimeUtils.clearTime(DateTime.utc())
            .minus({
            months: 1
        })
            .set({
            day: 1,
        })
            .toJSDate();
    }
    static getUtcLastMonthEnd() {
        return DateTimeUtils.clearTime(DateTime.utc())
            .set({
            day: 1,
        })
            .minus({
            days: 1
        })
            .toJSDate();
    }
    static getUtcWeekday(weekday, date) {
        let dateTimeToUse;
        if (!date) {
            dateTimeToUse = DateTime.utc();
        }
        else {
            dateTimeToUse = DateTime.fromJSDate(date, { zone: 'UTC' });
        }
        return DateTimeUtils.clearTime(dateTimeToUse)
            .set({
            weekday: weekday
        })
            .toJSDate();
    }
    static getDateFromUnixTimestampInSeconds(unixTimestamp) {
        // Create a new JavaScript Date object based on the unix timestamp
        // multiplied by 1000 so that the argument is in milliseconds, not seconds.
        return new Date(unixTimestamp * 1000);
    }
    static formatDate(date, format = DateTimeUtils.DATE_FORMAT) {
        return DateTime.fromJSDate(date, { zone: 'UTC' })
            .toFormat(format);
    }
    static parseDate(dateStr, format = DateTimeUtils.DATE_FORMAT) {
        const parsedDate = DateTime.fromFormat(dateStr, format, { zone: 'UTC' });
        return parsedDate.isValid ? parsedDate.toJSDate() : DateTimeUtils.getUtcToday();
    }
    static convertUTCtoLocalDate(date) {
        // Convert from UTC Date to string and from string to Local Date
        return DateTime.fromFormat(DateTimeUtils.formatDate(date), DateTimeUtils.DATE_FORMAT).toJSDate();
    }
    static clearUTCTime(date) {
        date.setUTCHours(0, 0, 0, 0);
        return date;
    }
    static convertLocalToUTCDate(date = new Date()) {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    }
    static diff(dateA, dateB, unit = 'days') {
        const dateTimeA = DateTime.fromJSDate(dateA, { zone: 'UTC' });
        const dateTimeB = DateTime.fromJSDate(dateB, { zone: 'UTC' });
        return Math.abs(dateTimeA.diff(dateTimeB, unit)[unit]);
    }
    static isTodayBetweenUTCRange(startDate, endDate) {
        const today = this.getUtcNow();
        const start = this.convertLocalToUTCDate(startDate);
        const end = this.convertLocalToUTCDate(endDate);
        return today >= start && today <= end;
    }
    static clearTime(date) {
        return date.set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0,
        });
    }
}
DateTimeUtils.ONE_DAY_IN_MS = 24 * 3600 * 1000;
DateTimeUtils.DATE_FORMAT = 'yyyy-MM-dd';
DateTimeUtils.DATE_HOUR_MINUTE_FORMAT = 'yyyy-MM-dd HH:mm';
DateTimeUtils.DATETIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
//# sourceMappingURL=DateTimeUtils.js.map